import { z } from "zod";

export const inviteUserZod = z.object({
  email: z.string().email(),
  name: z.string().min(1, "Name is required"),
});

export type InviteUserInput = z.infer<typeof inviteUserZod>;
